module.exports = "pegasus_template/assets/advanced-image-text-header-preview.png";